import { Link } from 'react-router-dom';

const stats = [
  { value: '6,000m+', label: '水源海拔' },
  { value: '10,000+', label: '冰川年份（年）' },
  { value: '50+', label: '覆盖国家与地区' },
  { value: '99.9%', label: '客户满意度' },
];

export default function BrandIntro() {
  return (
    <section className="py-16 md:py-24 px-4 md:px-6 lg:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="lg:w-1/2">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=A%20crystal%20clear%20glass%20bottle%20of%20premium%20mineral%20water%20placed%20on%20a%20minimal%20white%20marble%20surface%20with%20soft%20natural%20lighting%20from%20a%20large%20window%2C%20elegant%20product%20photography%2C%20clean%20aesthetic%2C%20subtle%20shadows%2C%20premium%20brand%20feel%2C%20translucent%20water%20droplets%20on%20the%20bottle%2C%20sophisticated%20minimalist%20composition&width=800&height=600&seq=brand-intro-kunlun&orientation=landscape"
                alt="昆仑雪高端矿泉水产品展示"
                title="昆仑雪 - 极致纯净的高端矿泉水"
                className="w-full h-auto rounded-2xl object-cover"
              />
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-primary-100/70 rounded-2xl -z-10"></div>
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="text-xs font-medium tracking-[0.2em] text-primary-600 uppercase font-heading">
              BRAND STORY
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mt-3 mb-5 leading-tight">
              源自昆仑，<br />只为极致纯净
            </h2>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-6">
              昆仑雪的水源地位于昆仑山脉海拔6000米以上的万年冰川区域。这里远离现代工业文明，保持着地球上最原始纯净的自然状态。每一滴昆仑雪都经过数万年的自然过滤和岩层渗透，汲取了丰富的矿物质和微量元素。
            </p>
            <p className="text-foreground-600 leading-relaxed text-sm md:text-base mb-8">
              我们建立完善的水源地生态保护体系，采用世界领先的无菌灌装技术，确保每一瓶昆仑雪都保持其在雪山之巅时的纯净品质。
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-8">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">{stat.value}</p>
                  <p className="text-xs text-foreground-500 mt-1">{stat.label}</p>
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
            >
              了解更多品牌故事
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}